import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';
import scopeImage from '../../../Assets/ResearchLabs/Common/AI Domains/GSAGL-Domain-AI.png';

const { Paragraph, Title } = Typography;

const Scope = () => (
  <section className="scope-section">
    <div className="scope-section-inner">
      <Row gutter={[72, 40]} align="middle" justify="space-between">
        <Col xs={24} md={14}>
          <Title level={2} className="scope-title">Scope</Title>
          <Divider className="ncgsa-divider" />
          <Paragraph className="scope-description">Pakistan is located in one of the world’s most tectonically and seismically active regions. Active tectonics create frequent geohazards, including landslides and earthquakes, with significant human and economic losses. At the same time, Pakistan has valuable mineral resources with considerable potential to improve national socio-economic conditions.</Paragraph>
          <Paragraph className="scope-description">Because of limited modern technology, many mineral resources in rough and inaccessible terrain remain unexplored. Water and forests are also critical national resources whose characterization and monitoring can support sustainable use.</Paragraph>
          <Paragraph className="scope-description">G-SAGL uses advanced GIS techniques, remote-sensing data, and in-situ measurements for geoscience applications, focusing on geohazards, geological applications, forests, and water resources.</Paragraph>
        </Col>
        <Col xs={24} md={9}>
          <div className="scope-image-wrap">
            <img src={scopeImage} alt="GIS and geosciences applications" className="scope-image" />
          </div>
        </Col>
      </Row>
    </div>
  </section>
);

export default Scope;
